module.exports = __webpack_public_path__ + "img/Fototeam.fe5e71cb.png";